import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { Distrolist } from 'types/distrolist.types';

type ListEventDistrolistInvitesQueryResponse = {
  eventDistrolistInvites: {
    list: Distrolist[];
  };
};

const LIST_EVENT_DISTROLIST_INVITES_QUERY = gql`
  query ListEventDistrolistInvites($eventId: Int!) {
    eventDistrolistInvites(eventId: $eventId) {
      list {
        id
        name
        memberCount
      }
    }
  }
`;

type DeleteEventDistrolistInviteQueryResponse = {
  removeDistrolistForEvent: {
    ok: boolean;
  };
};

const DELETE_EVENT_DISTROLIST_INVITE_MUTATION = gql`
  mutation DeleteEventDistrolistInvite($eventId: Int!, $distrolistId: Int!) {
    removeDistrolistForEvent(eventId: $eventId, distrolistId: $distrolistId) {
      ok
    }
  }
`;

const distrolistInvitesApi = {
  list: async (
    eventId: number
  ): Promise<ListEventDistrolistInvitesQueryResponse['eventDistrolistInvites']['list']> => {
    return gqlClient
      .request<ListEventDistrolistInvitesQueryResponse>(LIST_EVENT_DISTROLIST_INVITES_QUERY, {
        eventId
      })
      .then((res) => res.eventDistrolistInvites.list);
  },
  delete: async (
    eventId: number,
    distrolistId: number
  ): Promise<DeleteEventDistrolistInviteQueryResponse['removeDistrolistForEvent']['ok']> => {
    return gqlClient
      .request<DeleteEventDistrolistInviteQueryResponse>(DELETE_EVENT_DISTROLIST_INVITE_MUTATION, {
        eventId,
        distrolistId
      })
      .then((res) => res.removeDistrolistForEvent.ok);
  }
};

export { distrolistInvitesApi };
